module.exports = __webpack_public_path__ + "img/seo.d1eed82.png";